<div class="header-bar">
  <h1>Telephony Number Assignment</h1>
</div>

<div class="content-container">
  <p-tabView [(activeIndex)]="activeIndex">
    <!-- Organisation Tab -->
    <p-tabPanel header="Organisation">
      <div class="filterPanel">
        <div class="flex flex-wrap">
          <div>Select Organisation:</div>
          <div style="min-width: 300px">
            <organisation-select-list
              [minTextLength]="2"
              [selectPlaceHolderText]="'Type to select organisation'"
              (valueChange)="onOrganisationChange($event)"
            ></organisation-select-list>
          </div>
        </div>
      </div>

      <div *ngIf="selectedOrganisationData">
        <div class="card">
          <table>
            <tbody>
              <tr>
                <td align="right">Organisation:</td>
                <td>
                  <b>{{ selectedOrganisationData.name }}</b>
                </td>
              </tr>
              <tr>
                <td align="right">Address:</td>
                <td>
                  <b>{{ selectedOrganisationData.address }}</b>
                </td>
              </tr>
              <tr>
                <td align="right">Postcode:</td>
                <td>
                  <b>{{ selectedOrganisationData.postcode }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <div class="flex flex-wrap">
            <div class="flex-grow-1">
              <h2 class="sub-header-bar">
                Telephone Numbers for {{ selectedOrganisationData.name }}
              </h2>
            </div>
          </div>
          <div class="mt-1">
            <ng-container
              *ngTemplateOutlet="
                phoneNumberTable;
                context: {
                  numbers: selectedOrganisationData.organisationPhoneNumbers,
                  isEditable: true,
                  onEdit: cellEdit,
                  onDelete: deleteNumber,
                  isDelisted: false
                }
              "
            ></ng-container>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <!-- Search numbers tab -->
    <p-tabPanel header="Search Numbers">
      <div class="filterPanel">
        <div class="flex flex-wrap">
          <div
            class="flex-grow-1"
            style="align-content: center; max-width: 300px; margin-right: 20px"
          >
            <span class="md-inputfield filterItem">
              <input
                id="searchNumber"
                autofocus
                [(ngModel)]="searchPhoneText"
                autocomplete="off"
                class="search-box"
                pInputText
                placeholder="Search Number"
                spellcheck="false"
                type="text"
                (keyup.enter)="searchPhoneTextChanged(searchPhoneText)"
              />
            </span>
          </div>
          <div class="flex-shrink-1" style="align-content: center">
            <p-checkbox
              [(ngModel)]="excludeDelisted"
              id="autoClose"
              binary="true"
              (click)="excludeDelistedChange()"
              label="Exclude Delisted Numbers"
            ></p-checkbox>
          </div>
          <div class="flex-grow-1" style="align-content: center; text-align-last: right">
            <button
              pButton
              label="Search"
              icon="fa fa-search"
              (click)="searchPhoneTextChanged(searchPhoneText)"
            ></button>
          </div>
        </div>
      </div>

      <div *ngIf="filteredPhoneNumbers">
        <div>
          <div class="flex flex-wrap">
            <div class="flex-grow-1 mt-2">
              <h2 class="sub-header-bar text-center">
                Listing {{ filteredPhoneNumbers.length }} numbers
              </h2>
            </div>
          </div>
          <div class="mt-1">
            <ng-container
              *ngTemplateOutlet="
                phoneNumberFullTable;
                context: {
                  numbers: filteredPhoneNumbers,
                  isEditable: true,
                  onEdit: cellEdit,
                  onDelete: deleteNumber,
                  isDelisted: false
                }
              "
            ></ng-container>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <!-- Delisted Numbers Tab -->
    <p-tabPanel header="Delisted Numbers">
      <div *ngIf="delistedNumbers">
        <div class="flex flex-wrap">
          <div class="flex-grow-1">
            <h2 class="sub-header-bar">'Delisted' Telephone Numbers</h2>
          </div>
          <div class="flex-shrink-1">
            <span class="md-inputfield filterItem">
              <input
                id="telephoneInput"
                #orgNameInput
                autofocus
                (ngModelChange)="searchTextChanged($event)"
                [ngModel]="searchText"
                autocomplete="off"
                class="search-box"
                name="orgName"
                pInputText
                placeholder="Search Delisted Number"
                spellcheck="false"
                type="text"
              />
            </span>
          </div>
        </div>

        <div class="mt-1">
          <ng-container
            *ngTemplateOutlet="
              phoneNumberTable;
              context: {
                numbers: filteredDelistedNumbers,
                isEditable: false,
                onDelete: deleteNumber,
                isDelisted: true
              }
            "
          ></ng-container>
        </div>
      </div>
    </p-tabPanel>

    <!-- Warnings Tab -->
    <p-tabPanel header="Warnings">
      <!--      <p-messages [(value)]="warnings"></p-messages>-->
      <div class="warnings-container">
        <div *ngIf="loadingWarnings" class="loading-state">
          <i class="pi pi-spin pi-spinner"></i>
          <span>Loading warnings...</span>
        </div>

        <div *ngIf="!loadingWarnings" class="warnings-list">
          <div *ngFor="let warning of warnings" class="warning-item">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ warning.detail }}</span>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<ng-template
  #phoneNumberTable
  let-numbers="numbers"
  let-isEditable="isEditable"
  let-onEdit="onEdit"
  let-onDelete="onDelete"
  let-isDelisted="isDelisted"
>
  <p-table
    [value]="numbers"
    [responsive]="true"
    resizableColumns="true"
    class="fixed-table"
    selectionMode="none"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="phoneNumber">Phone Number</th>
        <th pSortableColumn="lastUpdated">Updated</th>
        <th pSortableColumn="updatedBy">Updated By</th>
        <th>Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          <input
            *ngIf="isEditable"
            pInputText
            [(ngModel)]="item.phoneNumber"
            (change)="onEdit(item)"
            [ngModelOptions]="{ standalone: true }"
            appendTo="body"
          />
          <span *ngIf="!isEditable">{{ item.phoneNumber }}</span>
        </td>
        <td>{{ item.lastUpdated | datex : 'ddd DD MMM HH:mm' }}</td>
        <td>{{ item.updatedBy }}</td>
        <td>
          <button
            type="button"
            class="ui-button-danger btn-to-right"
            pButton
            (click)="onDelete(item, isDelisted)"
            icon="fa ui-icon-trash"
            label="Delete"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>

<ng-template
  #phoneNumberFullTable
  let-numbers="numbers"
  let-isEditable="isEditable"
  let-onEdit="onEdit"
  let-onDelete="onDelete"
  let-isDelisted="isDelisted"
>
  <p-table
    [value]="numbers"
    [responsive]="true"
    resizableColumns="true"
    class="fixed-table"
    selectionMode="none"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="phoneNumber">Phone Number</th>
        <th pSortableColumn="organisationName">Associated Organisation</th>
        <th pSortableColumn="userName">Associated User</th>
        <th pSortableColumn="lastUpdated">Updated</th>
        <th pSortableColumn="updatedBy">Updated By</th>
        <th>Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          <input
            *ngIf="isEditable"
            pInputText
            [(ngModel)]="item.phoneNumber"
            (change)="onEdit(item)"
            [ngModelOptions]="{ standalone: true }"
            appendTo="body"
          />
          <span *ngIf="!isEditable">{{ item.phoneNumber }}</span>
        </td>
        <td>
          <span *ngIf="!item.organisationName">Delisted</span>
          <span *ngIf="item.organisationName"
            >{{ item.organisationName }}&nbsp;{{
              item.organisationActive ? '' : '(Inactive)'
            }}</span
          >
        </td>
        <td>
          {{ item.userName || 'Not Set' }} &nbsp;{{
            !item.userActive && item.userName ? '(Inactive)' : ''
          }}
        </td>
        <td>{{ item.lastUpdated | datex : 'ddd DD MMM HH:mm' }}</td>
        <td>{{ item.updatedBy }}</td>
        <td>
          <button
            type="button"
            class="ui-button-danger btn-to-right"
            pButton
            (click)="onDelete(item, isDelisted)"
            icon="fa ui-icon-trash"
            label="Delete"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>

<p-dialog
  header="Add Telephone Number"
  [(visible)]="showAddDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '640px' }"
>
  <div class="grid">
    <div class="col-12">
      <div class="col-7">Organisation: {{ selectedOrganisationData?.name }}</div>
      <div class="col-5">
        <input pInputText [(ngModel)]="newPhoneNumber" [style]="{ width: '100%' }" />
      </div>
    </div>
  </div>

  <div style="float: right; margin-top: 50px; padding: 8px">
    <button type="button" class="green-btn" pButton label="Add" (click)="addPhoneNumber()"></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Cancel"
      (click)="showAddDialog = false"
    ></button>
  </div>
</p-dialog>

<p-confirmDialog
  header="Confirmation"
  icon="fa ui-icon-question"
  [style]="{ width: '425px' }"
  acceptLabel="Delete"
  rejectLabel="Cancel"
></p-confirmDialog>
